import { createWebHashHistory, createRouter } from 'vue-router'

const Login = () => import('@/components/routes/login/Login.vue')
const Dashboard = () => import('@/components/routes/dashboard/Dashboard.vue')
const Delivery = () => import('@/components/routes/delivery/Delivery.vue')
const Settings = () => import('@/components/routes/settings/Settings.vue')
const Statistics = () => import('@/components/routes/statistics/Statistics.vue')
const Status = () => import('@/components/routes/status/Status.vue')
/* eslint-disable */

const routes = [
    {
        path     : '/',
        name     : 'default',
        component: Login
    },
    {
        path     : '/login',
        name     : 'login',
        component: Login
    },
    {
        path     : '/dashboard',
        name     : 'dashboard',
        component: Dashboard
    },
    {
        path     : '/delivery',
        name     : 'delivery',
        component: Delivery
    },
    {
        path     : '/statistics',
        name     : 'statistics',
        component: Statistics
    },
    {
        path     : '/settings',
        name     : 'settings',
        component: Settings
    },
    {
        path     : '/status',
        name     : 'status',
        component: Status
    }

]

const router = createRouter( {
    routes,
    history: createWebHashHistory(),
    scrollBehavior( to, from, savedPosition )
    {
        if( to.hash )
        {
            return {
                selector: to.hash,
                behavior: 'smooth'
            }
        }
    }
} )

router.beforeEach( ( to, from, next ) =>
{

    if( from.path === to.path )
    {
        console.log( 'FROM TO EXACT MATCH' )
        next()
        return
    }

    let routesAllowed = [
        'setup',
        'login'
    ]

    let element = document.querySelector( '#header' )
    if( null !== element )
    {
        element.scrollIntoView( { behavior: 'smooth' } )
    }

    if( -1 < routesAllowed.indexOf( to.name ) )
    {
        console.log( '>>> ROUTE ALLOWED BY DEFAULT' )
        next()
    }
    else
    {
        if( undefined === window.authKey )
        {
            setTimeout( () =>
            {
                if( null !== window.authKey
                    && undefined !== window.authKey )
                {
                    console.log( '>>> ROUTING AFTER TIMEOUT' )
                    next()
                }
                else
                {
                    console.log( '>>> ROUTING TO DEFAULT AFTER TIMEOUT' )
                    next( { name: 'default' } )
                }
            }, 200 )
        }
        else
        {
            if( null !== window.authKey )
            {
                console.log( '>>> ROUTING TO TARGET', to.path )
                next()
            }
            else
            {
                console.log( '>>> ROUTING TO DEFAULT' )
                next( { name: 'default' } )
            }
        }

    }

} )

export default router